<template>
  <div>
    <a-table
      :rowKey="
        (record, index) => {
          return index
        }
      "
      :columns="columns"
      :loading="tableLoading"
      :pagination="pagination"
      @change="handleChangeInTable"
      :data-source="transactionHistoryList"
      :customRow="getContractDetail"
    >
      <a slot="name" slot-scope="text">{{ text }}</a>
      <template slot="contractCode" slot-scope="contractCode">
        <h1 style="color: var(--ThemeColor)">{{ contractCode }}</h1>
      </template>
    </a-table>
  </div>
</template>
<script>
import { contractsInfoList } from '@/api/system/contract'
    // 表格数据
const columns = [
  {
    title: '合同',
    dataIndex: 'contractCode',
    key: '1',
    scopedSlots: {
      customRender: 'contractCode',
    },
  },
  {
    title: '品牌',
    dataIndex: 'shopName',
    key: '2',
  },
  {
    title: '成交时间',
    dataIndex: 'signDate',
    key: '4',
    ellipsis: true,
  },
  {
    title: '成交价格',
    dataIndex: 'rentExpense',
    key: '5',
    ellipsis: true,
  },
  {
    title: '房佣',
    dataIndex: 'lessorComm',
    key: '6',
    ellipsis: true,
  },
  {
    title: '客佣',
    dataIndex: 'lesseeComm',
    key: '7',
    ellipsis: true,
  },
]
export default {
    props:{
        houseId: {
            type: String,
            require: true,
        },
        rentSaleType:{
            type:String,
            default:'1',
            require:true
        }
    },
  data() {
    return {
      columns,
      tableLoading: false,
      // 成交历史表格数据
      transactionHistoryList: [],
      // 分页参数
      pagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          // range[0] + '-' + range[1] +
          return ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
    }
  },
  mounted(){
    this.getTransactionHistoryList()
  },
  methods:{
    // 历史成交分页
    handleChangeInTable (pagination, filters, sorter) {
      // 分页、排序、筛选变化时触发
      this.pagination = pagination
      this.getTransactionHistoryList()
    },
    getContractDetail: function (record, index) {
      return {
        on: {
          click: () => {
            this.$router.push({
              path: '/contract/details',
              query: { id: record.id }
            })
          }
        }
      }
    },
   // 成交历史
    getTransactionHistoryList () {
      const params = {
        houseId: this.houseId,
        rentSaleType: this.rentSaleType,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
      this.tableLoading = true
      contractsInfoList(params).then(({ code, data }) => {
        this.tableLoading = false
        if (code === 200) {
          this.transactionHistoryList = data.records
          this.pagination.total = data.total
        }
      })
    },
  }
}
</script>